import { createSelector } from "reselect"
import { forEach, get } from "lodash"
import { getPortfolioPositions } from "modules/compare-frontier/selectors/data"

const splitPortfolioMv = createSelector(
  [getPortfolioPositions],
  portfolioPositions => {
    let lmv = 0
    let smv = 0

    const splitEconomicExposure = (type) => {
      forEach(get(portfolioPositions, type), ({ economicExposure }) => {
        if (economicExposure < 0) {
          smv -= economicExposure
        } else {
          lmv += economicExposure
        }
      })
    }

    splitEconomicExposure("equities")
    splitEconomicExposure("currencies")
    splitEconomicExposure("commodities")
    splitEconomicExposure("fixedIncome")
    splitEconomicExposure("otherAssets")
    splitEconomicExposure("indexes")
    splitEconomicExposure("swaps")

    return { lmv, smv }
  },
)

export const getPortfolioLmv = createSelector(
  [splitPortfolioMv],
  ({ lmv }) => lmv,
)

export const getPortfolioSmv = createSelector(
  [splitPortfolioMv],
  ({ smv }) => smv,
)

export const getPortfolioNetLong = createSelector(
  [splitPortfolioMv],
  ({ lmv, smv }) => {
    const total = lmv + smv
    if (total === 0) {
      return total
    } else {
      return lmv / total
    }
  },
)
